import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewKanban = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	enableBackground: "new 0 0 24 24",
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: -16667e-9,
			y: -16667e-9,
			width: 20,
			height: 20,
			fill: "none",
			strokeWidth: .83333
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1.1111 0 0 1.1111 -3.3333 -3.3333)",
			children: /* @__PURE__ */ _jsx("path", { d: "m19 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2zm-10 14h-2v-10h2zm4-5h-2v-5h2zm4 3h-2v-8h2z" })
		})
	]
});
const ForwardRef = forwardRef(SvgViewKanban);
export { ForwardRef as ReactComponent };
